<script setup lang="ts">
import { ref } from 'vue';
import ShapeTab from './ShapeTab.vue';
import EmojiTab from './EmojiTab.vue';

defineProps<{
  publicPath: string;
}>();

const tab = ref<'shapes' | 'emoji'>('shapes');
</script>

<template>
  <section class="vptw:flex vptw:flex-col vptw:gap-2">
    <div class="vptw:grid vptw:grid-cols-2 vptw:rounded-lg vptw:bg-(--vs-surface-2) vptw:p-1">
      <button
        type="button"
        class="vptw:rounded-md! vptw:border-0! vptw:px-3! vptw:py-1.5! vptw:text-xs! vptw:font-semibold! vptw:cursor-pointer"
        :class="tab === 'shapes' ? 'vptw:bg-(--vs-surface)! vptw:text-(--vs-ink)! vptw:shadow-sm' : 'vptw:bg-transparent! vptw:text-(--vs-ink-2)!'"
        @click="tab = 'shapes'"
      >
        Shapes
      </button>
      <button
        type="button"
        class="vptw:rounded-md! vptw:border-0! vptw:px-3! vptw:py-1.5! vptw:text-xs! vptw:font-semibold! vptw:cursor-pointer"
        :class="tab === 'emoji' ? 'vptw:bg-(--vs-surface)! vptw:text-(--vs-ink)! vptw:shadow-sm' : 'vptw:bg-transparent! vptw:text-(--vs-ink-2)!'"
        @click="tab = 'emoji'"
      >
        Emoji
      </button>
    </div>

    <ShapeTab v-if="tab === 'shapes'" />
    <EmojiTab v-else :public-path="publicPath" />
  </section>
</template>
